'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = require('react-redux');

var _content = require('../actions/content');

var _emitters = require('../actions/emitters');

var _Item = require('../components/Item');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * src/containers/Item.js
 * Author: H.Alper Tuna <halpertuna@gmail.com>
 * Date: 16.09.2016
 */

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    toggleSubMenu: function toggleSubMenu(e) {
      if (!ownProps.hasSubMenu) return;
      e.preventDefault();
      dispatch((0, _content.changeSubMenuVisibility)(ownProps.reduxUid, ownProps.id, ownProps.trace, !ownProps.subMenuVisibility));
    },
    activateMe: function activateMe(e) {
      dispatch((0, _emitters.emitSelected)(ownProps.reduxUid, e));
      if (!e || !e.isDefaultPrevented || !e.isDefaultPrevented()) {
        dispatch((0, _content.changeActiveLinkId)(ownProps.reduxUid, ownProps.id));
      }
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_Item2.default);